<template>
    <div>
        <h1 class="title is-4 my-5">Datos interesantes</h1>
        <p>
            N° de Saludos vendidos (ultima version):
            <strong> {{ dataChart ? dataChart.length : '' }} </strong>
        </p>
        <p>
            Total recaudado (ultima version):
            <strong> {{ total }} </strong>
        </p>
        <p>
            Ultima venta:
            <strong> {{ lastSell }} </strong>
        </p>
        <p class="mt-6">Click para descargar la BD en un archivo excel:</p>
        <a
            href="https://saludosconsentido-be.coaniquem.cl/export/excel"
        >
            <button class="button is-primary">Descargar excel aquí</button>
        </a>
        <div class="columns mt-6">
            <div class="column is-half is-offset-1" v-if="dataChart">
                <highcharts :options="categoryBar"></highcharts>
            </div>
        </div>
        <div class="columns mt-6">
            <div class="column is-half is-offset-1" v-if="dataChart">
                <highcharts :options="payPlanform"></highcharts>
            </div>
        </div>
    </div>
</template>
<script>
import { Chart } from 'highcharts-vue'
import { UrlChart, UrlCategory } from '../../Url'

export default {
    components: {
        highcharts: Chart,
    },
    mounted() {
        this.getData()
        this.fetchCategory()
    },
    data() {
        return {
            dataChart: null,
            total: 0,
            lastSell: null,
            categories: '',
            payPlanform: {
                chart: {
                    type: 'bar',
                },
                title: {
                    text: 'Plataformas de pago',
                },
                xAxis: {
                    categories: ['Opciones'],
                },
                series: [
                    {
                        name: 'Khipu',
                        data: [0],
                    },
                    {
                        name: 'Webpay',
                        data: [0],
                    },

                ],
            },
            categoryBar: {
                chart: {
                    type: 'bar',
                },
                title: {
                    text: 'Categorias mas comprada',
                },
                xAxis: {
                    categories: ['Categorias:'],
                },
                series: [
                    {
                        name: 'Coronas de Caridad',
                        data: [0],
                    },
                    {
                        name: 'Agradecimientos de condolencias',
                        data: [0],
                    },
                    {
                        name: 'Canastillos de novios',
                        data: [0],
                    },
                    {
                        name: 'Nacimientos y Bautizos',
                        data: [0],
                    },
                    {
                        name: 'Cumpleaños y aniversarios',
                        data: [0],
                    },
                    {
                        name: 'Saludos para enfermos',
                        data: [0],
                    },
                    {
                        name: 'Solicitud de misa',
                        data: [0],
                    },
                    {
                        name: 'Tarjetas de Navidad',
                        data: [0],
                    },
                    {
                        name: 'Tarjetas de Navidad Para Empresas',
                        data: [0],
                    },
                    {
                        name: 'Efemérides',
                        data: [0],
                    },
                ],
            },
        }
    },
    methods: {
        getData: function () {
            const vm = this
            let token = JSON.parse(sessionStorage.getItem('vue-session-key'))
            fetch(UrlChart, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token.jwt,
                },
            })
                .then((res) => res.json())
                .then((datos) => {
                    vm.dataChart = datos
                    vm.setPaymentPlatform(datos)
                    vm.setCategoryBar(datos)
                    vm.setTotal(datos)
                    vm.setLastSell(datos)
                })
        },
        fetchCategory: function () {
            const vm = this
            fetch(UrlCategory)
                .then((res) => res.json())
                .then((datos) => {
                    vm.categories = datos.data
                })
        },
        setPaymentPlatform: function (datos) {
            const webpay = datos.filter(
                (d) => d.paymentPlatformName === 'Webpay'
            )
            const khipu = datos.filter((d) => d.paymentPlatformName === 'Khipu')
            this.payPlanform.series[0].data[0] = khipu.length
            this.payPlanform.series[1].data[0] = webpay.length
       
        },
        setCategoryBar: function (datos) {
            for (let i = 0; i < this.categories.length; i++) {
                this.categoryBar.series[i].data[0] = datos.filter(
                    (d) => d.categoryName === this.categories[i].name
                ).length
            }
        },
        setTotal: function (datos) {
            let count = 0
            const array = datos.map((t) => parseFloat(t.donation))
            const total = array.reduce((totalValue, currentValue) => {
                return totalValue + currentValue
            }, count)
            this.total = total
        },
        setLastSell: function (datos) {
            this.lastSell = datos[0].created_at
        },
    },
}
</script>
